import actionTypes from '../../actions/actionTypes'
import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'
import { updateItem, updateOrder } from './helpers'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.cliMovies)


const cliMoviesReducer = (state = INIT_STATE, action) => {

    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.CLIMOVIES_UPDATE_ITEM:
            return updateItem(state, action)
        case actionTypes.CLIMOVIES_UPDATE_ORDER:
            return updateOrder(state, action)
        default:
            return state;
    }
}

export default cliMoviesReducer;